import { NoAccessCard } from "@impero-com/common/components/noAccessCard/index";
import createIcon from "@impero-com/common/img/create-icon.svg";
import { ActionMenu, actionMenuStatus, NoContent } from "@impero-com/ui";
import { t } from "i18next";

import { useEntitiesQuery } from "org/entities/queries/useEntitiesQuery";
import { WebRoute } from "routes";
import { useUserStatusQuery } from "utils/queries/useUserStatusQuery";

import { OrgApplicationBar } from "../../../components/applicationBar/orgApplicationBar";
import { useNewMenu } from "../../navigation/useNewMenu";
import { SettingsLayout } from "../../settings/SettingsLayout";

import { ControlEntitiesList } from "./ControlEntitiesList";

export function ControlEntitiesListPage() {
    const { data: userStatus } = useUserStatusQuery();
    const { data } = useEntitiesQuery({ all: false, scope: "control" });
    const newMenu = useNewMenu();

    const canCreate = userStatus.actions.controlEntities.create;
    const hasEntities = data.content.length > 0;

    const actions = [
        {
            id: "menuitem-1",
            label: t("Entities_Create_Title"),
            icon: { svg: createIcon },
            link: { to: WebRoute.ENTITIES_NEW },
            status: actionMenuStatus(canCreate, t("Entity_Create_Forbidden")),
        },
    ];

    function renderContent() {
        if (hasEntities) {
            return <ControlEntitiesList data={data} />;
        }
        if (canCreate) {
            return (
                <NoContent
                    header={t("ControlEntitiesList_NoContent_Header")}
                    description={t("ControlEntitiesList_NoContent_Description")}
                    actionCreation={{
                        type: "ROUTER",
                        label: t("ControlEntitiesList_NoContent_Action"),
                        to: WebRoute.ENTITIES_NEW,
                    }}
                />
            );
        }
        return <NoAccessCard />;
    }

    if (newMenu) {
        return (
            <SettingsLayout
                section="entities"
                actions={<ActionMenu id="action-menu" actions={actions} />}
            >
                {renderContent()}
            </SettingsLayout>
        );
    }

    return (
        <OrgApplicationBar
            title={t("EntityDefinition_Title")}
            actions={{
                id: "action-menu",
                actions,
            }}
        >
            {renderContent()}
        </OrgApplicationBar>
    );
}
